/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Tanggal Melamar',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Total Pelamar',
  },
]

const data = [
  {
    name: 'Frontend Developer ReactJs',
    applyDate: '12 September 2022',
    status: 'Aktif',
    totalApplicant: '120 Orang',
  },
  {
    name: 'Frontend Developer ReactJs',
    applyDate: '12 September 2022',
    status: 'Dalam Proses',
    totalApplicant: '120 Orang',
  },
  {
    name: 'Frontend Developer ReactJs',
    applyDate: '12 September 2022',
    status: 'Tutup',
    totalApplicant: '120 Orang',
  },
  {
    name: 'Frontend Developer ReactJs',
    applyDate: '12 September 2022',
    status: 'Aktif',
    totalApplicant: '120 Orang',
  },
  {
    name: 'Frontend Developer ReactJs',
    applyDate: '12 September 2022',
    status: 'Aktif',
    totalApplicant: '120 Orang',
  },
]

const StatusComponent = (status: string) => {
  if (status === 'Aktif') {
    return (
      <button
        style={{
          background: '#E8FEF3',
          borderRadius: '10px',
          color: '#50CD89',
          padding: '0.5rem',
          width: '87px',
          border: 'none',
        }}
        className='shadow-none'
      >
        Aktif
      </button>
    )
  }
  if (status === 'Dalam Proses') {
    return (
      <Button
        variant='primary'
        style={{
          background: '#F1FAFF',
          borderRadius: '10px',
          color: '#FF6C06',
          padding: '0.5rem',
          outline: 'none',
          border: 'none',
        }}
      >
        Dalam Proses
      </Button>
    )
  }
  if (status === 'Tutup') {
    return (
      <Button
        variant='danger'
        style={{
          background: '#FFF5F8',
          borderRadius: '10px',
          color: '#F1416C',
          padding: '0.5rem',
          outline: 'none',
          border: 'none',
        }}
      >
        Tutup
      </Button>
    )
  }
}

const DashboardPage: FC = () => (
  <>
    <div className='row'>
      {[1, 2, 3].map((item) => {
        return (
          <div className='col-md-4' key={item}>
            <div className='card-custom'>
              <h4 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>24.000</h4>
              <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Lowongan Kerja</span>
              <br />
              {/* <ButtonMUI variant="text">Lihat Semua</ButtonMUI> */}
            </div>
          </div>
        )
      })}
    </div>
    <br />
    <div className='row'>
      <div className='col-md-12'>
        <div className='card-custom'>
          <h4>Lowongan Pekerjaan</h4>
          <span>Status terbaru lowongan pekerjaan yang saya ajukan</span>
          <Table responsive className='table-striped align-middle'>
            <thead>
              <tr>
                <th>#</th>
                {heads.map((item, index) => (
                  <th key={index}>{item.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.applyDate}</td>
                    <td>{StatusComponent(item.status)}</td>
                    <td>{item.totalApplicant}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
